import ChatAdmin from "pages/Admin/ChatAdmin";

export default function ChatAdminPage() {
  return <ChatAdmin />;
}
